import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { subDays, startOfMonth, endOfMonth, format, isValid, addDays, setMonth } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Records } from '../../interfaces/records';
import { Stores } from '../../interfaces/stores';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-admin-records',
  templateUrl: './admin-records.component.html',
  styleUrls: ['./admin-records.component.css']
})
export class AdminRecordsComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private dateAdapter: DateAdapter<Date>

  ) { }
  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  //para trabajar con la peticion al servidor cada x segundos
  private apiSubcription:Subscription;

  ngOnInit(): void {
    this.dateAdapter.setLocale('es'); // Establece el idioma de las fechas a español
    this.mesActual = new Date();
    this.get();
    this.apiSubcription = interval(60000) // 5000 ms = 5 segundos
    .subscribe(() => {
      this.get();
    });
  }
  ngOnDestroy(): void {
    if (this.apiSubcription) {
      this.apiSubcription.unsubscribe();
    }
  }
  items: Records[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  facilityes:Facility[];
  stores:Stores[];

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  setDaysStartEnd() {
      this.inicioMes = startOfMonth(this.mesActual);
      this.finMes = endOfMonth(this.mesActual);
    this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
    this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
    this.get();
  }
  get() {
    this.api.paginateMyRecords(this.page, this.form.get('start')?.value, this.form.get('end')?.value).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Records[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
      }
    );
  }


  search() {
    this.get();
  }


  mesView: string;
  mesActual: Date;
  fechas: Date[];
  //dia inicial del mes
  inicioMes: Date;

  //dia final del mes
  finMes: Date;
  setStartDay(event: any) {
    this.form.get('start')?.setValue(event.value);
  }

  cambiarMes(delta: number): void {
    this.mesActual = setMonth(this.mesActual, this.mesActual.getMonth() + delta);
    this.mesView = this.mesActual.toISOString();
    this.setDaysStartEnd();
  
  }

  obtenerNombreMes(mes: number): string {
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    return nombresMeses[mes];
  }
  openModal(mdl: any) {
    this.modal.open(mdl);
  }


}

